import { useEffect, useState } from 'react'
import { FeatureToggle } from '../../legacy/contexts/featureToggles/FeatureToggleContext'
import { usePartnerId } from '../routing/params.hooks'
import { errors } from '../error-handling/errors'
import { useCheckLaunchOnboardingProgressByPartnerQuery } from '../../__codegen__/api'
import { type AccessControlConfig } from '../../legacy/components/AccessControl/accessControl.utils'

const LAUNCHED_WORKFLOW_STATE = 'launched'

export const onboardingAccessControl: AccessControlConfig = {
  featureToggles: [FeatureToggle.launchOnboarding],
}

export const useCheckLaunchOnboardingProgress = (skip?: boolean) => {
  const partnerId = usePartnerId({ throwOnMissing: false })
  const { data, loading, error } = useCheckLaunchOnboardingProgressByPartnerQuery({
    variables: { partnerId },
    skip: skip || !partnerId,
  })

  const [hasLaunchOnboarding, setHasLaunchOnboarding] = useState(false)
  const [hasInProgressLaunchOnboarding, setHasInProgressLaunchOnboarding] = useState(false)
  const [workflowState, setWorkflowState] = useState('')

  useEffect(() => {
    if (error) {
      errors.captureMessage(
        'useCheckLaunchOnboardingProgressByPartnerQuery call returned an error',
        {
          level: 'error',
        }
      )
    }
  }, [error])

  useEffect(() => {
    if (!partnerId) return

    setWorkflowState(data?.onboardingServiceCheckLaunchOnboardingProgressByPartner?.workflowState)
    if (workflowState) {
      setHasLaunchOnboarding(true)
      // the launch onboarding is considered in progress unless it's launched
      if (workflowState != LAUNCHED_WORKFLOW_STATE) {
        setHasInProgressLaunchOnboarding(true)
      }
    }
  }, [data, workflowState, partnerId])

  return {
    loading,
    hasInProgressLaunchOnboarding,
    hasLaunchOnboarding,
    workflowState,
    error,
  }
}
